import React from 'react';

const Button = ({ label = 'Download Content', content }) => {
    return (
        <a href={content} target='_blank' className="btn btn-purple mt-4 block lg:inline-block">{label}</a>
    );
};

export default Button;